var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('single-modal', {
    attrs: {
      "title": _vm.fatherDetailModalConfigs.title,
      "options": _vm.fatherDetailModalConfigs
    },
    on: {
      "API": function($event) {
        _vm.FatherDetailModal = $event
      }
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    }
  }, [(!_vm.emptyDetailData.typ) ? _c('div', {
    staticClass: "form-detail-field form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.fatherModalInputConfigs.type
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.fatherModalInputConfigs.type.val))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    staticClass: "form-detail form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.fatherModalInputConfigs.type.cod
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyDetailData.des) ? _c('div', {
    staticClass: "form-detail-field form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.fatherModalInputConfigs.description
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.fatherModalInputConfigs.description.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    staticClass: "form-detail form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "des_area",
      "rows": _vm.fatherModalInputConfigs.description.rows,
      "readonly": ""
    },
    domProps: {
      "value": _vm.fatherModalInputConfigs.description.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "modalDetail.feature_area",
      "tag": "div"
    }
  }, [(!_vm.emptyDetailData.spe) ? _c('div', {
    staticClass: "form-detail-field form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.fatherModalInputConfigs.feature
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.fatherModalInputConfigs.feature.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    staticClass: "form-detail form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "feature_area",
      "rows": _vm.fatherModalInputConfigs.feature.rows,
      "readonly": ""
    },
    domProps: {
      "value": _vm.fatherModalInputConfigs.feature.val
    }
  })])])], 1) : _vm._e()]), _vm._v(" "), (!_vm.emptyDetailData.pos) ? _c('div', {
    staticClass: "form-detail-field form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.fatherModalInputConfigs.position
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.fatherModalInputConfigs.position.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    staticClass: "form-detail form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.fatherModalInputConfigs.position.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyDetailData.qty) ? _c('div', {
    staticClass: "form-detail-field form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.fatherModalInputConfigs.quantity
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.fatherModalInputConfigs.quantity.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    staticClass: "form-detail form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.fatherModalInputConfigs.quantity.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyDetailData.spi) ? _c('div', {
    staticClass: "form-detail-field form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.fatherModalInputConfigs.codSost
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.fatherModalInputConfigs.codSost.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-detail form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.fatherModalInputConfigs.codSost.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyDetailData.not) ? _c('div', {
    staticClass: "form-detail-field form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.fatherModalInputConfigs.not
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.fatherModalInputConfigs.not.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    staticClass: "form-detail form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "notes_area",
      "rows": _vm.fatherModalInputConfigs.not.rows,
      "readonly": ""
    },
    domProps: {
      "value": _vm.fatherModalInputConfigs.not.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyDetailData.val) ? _c('div', {
    staticClass: "form-detail-field form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.fatherModalInputConfigs.validity.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('grid', {
    attrs: {
      "columns": _vm.valListCfg.columns,
      "source": _vm.valList,
      "options": _vm.valGridOptions,
      "lang": _vm.$root.token.idLingua,
      "name": _vm.valListCfg.title,
      "selectParameter": _vm.$Behaviors.focusBy(),
      "select": _vm.focus
    },
    on: {
      "update:source": function($event) {
        _vm.valList = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.emptyDetailData.doc) ? _c('div', {
    staticClass: "form-detail-field form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.fatherModalInputConfigs.documents.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('grid', {
    attrs: {
      "columns": _vm.docListCfg.columns,
      "source": _vm.docList,
      "options": _vm.valGridOptions,
      "lang": _vm.$root.token.idLingua,
      "name": _vm.docListCfg.title,
      "selectParameter": _vm.$Behaviors.focusBy(),
      "select": _vm.focus
    },
    on: {
      "update:source": function($event) {
        _vm.docList = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.emptyDetailData.attr) ? _c('div', {
    staticClass: "form-detail-field form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.fatherModalInputConfigs.attributes.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('grid', {
    attrs: {
      "columns": _vm.attrListCfg.columns,
      "source": _vm.attrList,
      "options": _vm.attrGridOptions,
      "lang": _vm.$root.token.idLingua,
      "name": _vm.attrListCfg.title,
      "selectParameter": _vm.$Behaviors.focusBy(),
      "select": _vm.focus
    },
    on: {
      "update:source": function($event) {
        _vm.attrList = $event
      }
    }
  })], 1)]) : _vm._e()], 1)]), _vm._v(" "), _c('tab-modal', {
    attrs: {
      "tabs": _vm.modalTabs,
      "start": _vm.start,
      "options": _vm.userDataModalConfigs,
      "closeModal": _vm.saveChanges
    },
    on: {
      "API": function($event) {
        _vm.UserTabModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "user-modal-data tab-general",
    slot: "generalData"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.username
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "userField"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.username.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "userField",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.username.val
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.fullname
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "namField"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.fullname.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "namField",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.fullname.val
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.nomeGruppo
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "profileField"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.nomeGruppo.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.nomeGruppo.val
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.lang
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "langField"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.lang.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.lang.val
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "padding": "6px"
    },
    attrs: {
      "src": _vm.langFlag
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.mail
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "mailField"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.mail.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "mailField",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.mail.val
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.phone
    }
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "phoneField"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.phone.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "phoneField",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.phone.val
    }
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "user-modal-data",
    slot: "clientData"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    }
  }, [(_vm.$Behaviors.showClientLogo) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "logo"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('client logo')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.logoSrc
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3 control-label",
    staticStyle: {
      "cursor": "pointer",
      "padding-left": "0px",
      "padding-right": "40px"
    },
    on: {
      "click": function($event) {
        _vm.ChangeLogoModal.open()
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('change logo')))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3 control-label",
    staticStyle: {
      "cursor": "pointer",
      "padding-left": "0px",
      "padding-right": "40px"
    },
    on: {
      "click": function($event) {
        _vm.RemoveLogoModal.open()
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('remove logo')))])])]) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.ragSoc) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.ragSoc
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "ragsoc"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.ragSoc.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.ragSoc.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.codfis) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.codfis
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "codf"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.codfis.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.codfis.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.piva) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.piva
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "pIva"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.piva.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.piva.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.sito) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.sito
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "sito"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.sito.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.sito.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.nomeTit) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.nomeTit
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "nomeTit"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.nomeTit.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.nomeTit.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.contCli) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.contCli
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "contact"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.contCli.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.contCli.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.indCli) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.indCli
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.indCli.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.indCli.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.capCli) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.capCli
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "cap"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.capCli.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.capCli.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.provCli) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.provCli
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "prov"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.provCli.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.provCli.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.locCli) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.locCli
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "loc"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.locCli.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.locCli.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.nazCli) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.nazCli
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "country"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.nazCli.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.nazCli.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.telCli) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.telCli
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "tel"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.telCli.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.telCli.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.faxCli) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.faxCli
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "fax"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.faxCli.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.faxCli.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.cellCli) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.cellCli
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "cell"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.cellCli.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.cellCli.val
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emptyUserData.emailServ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.userInputConfigs.emailServ
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "cliMail"
    }
  }, [_vm._v(_vm._s(_vm.userInputConfigs.emailServ.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.userInputConfigs.emailServ.val
    }
  })])])], 1) : _vm._e()])])])]), _vm._v(" "), _c('single-modal', {
    ref: "ChangePwdModal",
    staticClass: "pwd-modal",
    attrs: {
      "title": _vm.$Jed.firstUpperTranslate('change password'),
      "options": _vm.changePwdModalConfigs
    },
    on: {
      "API": function($event) {
        _vm.ChangePwdModal = $event
      }
    }
  }, [_c('form', {
    staticClass: "form-horizontal modal-input",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.pwdInputConfigs.cur
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "curPwd"
    }
  }, [_vm._v(_vm._s(_vm.pwdInputConfigs.cur.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPassword),
      expression: "currentPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.currentPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPassword = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), (!_vm.existing) ? _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "existing"
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("La password non è corretta. Riprova.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.pwdInputConfigs.new
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "newPwd"
    }
  }, [_vm._v(_vm._s(_vm.pwdInputConfigs.new.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.matching) ? _c('i', {
    class: _vm.$root.icons.exclamation,
    staticStyle: {
      "color": "red"
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input-w', {
    attrs: {
      "configs": _vm.pwdInputConfigs.ok
    }
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "okNewPwd"
    }
  }, [_vm._v(_vm._s(_vm.pwdInputConfigs.ok.lbl))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmNewPassword),
      expression: "confirmNewPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.confirmNewPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmNewPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.matching) ? _c('i', {
    class: _vm.$root.icons.exclamation,
    staticStyle: {
      "color": "red"
    }
  }) : _vm._e()])], 1), _vm._v(" "), (!_vm.matching) ? _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "matching"
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Le password non corrispondono. Riprova.")])]) : _vm._e()])]), _vm._v(" "), _c('single-modal', {
    attrs: {
      "title": _vm.$Jed.firstUpperTranslate('change logo'),
      "options": _vm.changeLogoModalConfigs
    },
    on: {
      "API": function($event) {
        _vm.ChangeLogoModal = $event
      }
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group modal-input"
  }, [_c('input-w', [_c('input', {
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "aria-describedby": "fileHelp"
    }
  })])], 1)])]), _vm._v(" "), _c('single-modal', {
    attrs: {
      "title": _vm.$Jed.firstUpperTranslate('remove logo'),
      "options": _vm.removeLogoModalConfigs
    },
    on: {
      "API": function($event) {
        _vm.RemoveLogoModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-input"
  }, [_c('label', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('do you really want to remove the logo?')))])])]), _vm._v(" "), _c('single-modal', {
    attrs: {
      "title": _vm.$Jed.firstUpperTranslate('logout'),
      "options": _vm.doLogoutModalConfigs
    },
    on: {
      "API": function($event) {
        _vm.DoLogoutModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-input"
  }, [_c('label', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('do you really want to log out?')))])])]), _vm._v(" "), _c('header', {
    staticClass: "main-header"
  }, [_c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'open_catalog',
        visible: true
      },
      "icnClasses": ['toolbar', this.$root.icons.book + (_vm.$root.help ? ' help' : '') + (_vm.active == 'open_catalog' ? ' active' : '') + (_vm.$root.BLOCK_NAVIGATION ? ' disable' : '')],
      "styleObj": {
        'color': 'rgb(173, 178, 180)',
        'padding': '10px 7.5px',
        'margin-left': '0px',
        'display': 'block',
        'float': 'left',
        'cursor': 'pointer'
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.showContent : (!_vm.$root.help ? _vm.showContent : _vm.$root.trigger_help),
      "execParam": _vm.hoverTooltipEnabled ? ['open_catalog', null, null, 'pickIndex'] : !_vm.$root.help ? ['open_catalog', null, null, 'pickIndex'] : ['open_catalog'],
      "hoverParam": 'open_catalog'
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top resize-reset table-resize-reset navbar-color",
    class: [_vm.right ? 'side-right' : 'side-left'],
    attrs: {
      "role": "navigation"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "goto_brandsite",
      "href": "/"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        !_vm.$root.help ? _vm.goToBrandSite() : _vm.$root.trigger_help('goto_brandsite')
      }
    }
  }, [_c('div', {
    staticClass: "img-responsive center-block logo resize-reset table-resize-reset logo-wrapper",
    staticStyle: {
      "padding": "0px",
      "width": "auto",
      "height": "55px"
    },
    attrs: {
      "id": "logo_div"
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "100%"
    },
    attrs: {
      "src": _vm.logoSrc
    }
  })])])]), _vm._v(" "), _c('breadcrumb', {
    attrs: {
      "configs": {
        visible: true,
        full_path: true,
        nodes_shown: _vm.breadcrumb_nodes
      },
      "ulClasses": "top-breadcrumb",
      "ulStyle": {
        'border-radius': '0px',
        margin: '0px',
        'text-align': 'left'
      },
      "liStyle": {
        color: 'white'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "bottom": "10px",
      "right": "0px"
    }
  }, [(_vm.$Behaviors.showHelpModeIcon && this.sessionStorage.getItem('device') == 'desktop') ? _c('popover-alert', {
    attrs: {
      "effect": "fade",
      "placement": "left",
      "title": _vm.$Jed.firstUpperTranslate('help mode', null),
      "content": _vm.$Jed.firstUpperTranslate('you activated %1$s, click on a command to view his purpose', null, {
        key: 'help mode'
      }),
      "no": _vm.toggleHelpFlag,
      "popoverCondition": _vm.$root.help == true,
      "showOK": false,
      "no_text": _vm.$Jed.firstUpperTranslate('cancel'),
      "popoverStyle": {
        top: '10px',
        'max-width': '200px',
        width: '200px',
        'font-size': 'small',
        height: 'max-content'
      },
      "arrowStyle": {
        top: '12%'
      },
      "textStyle": {
        color: '#222'
      },
      "classes": ""
    }
  }, [_c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'noOverlay',
        visible: true
      },
      "icnClasses": [this.$root.icons.help + (_vm.active == 'toggle_help_flag' ? ' active' : ''), 'navbar-icon-right'],
      "exec": _vm.toggleHelpFlag,
      "hoverParam": 'notification'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('popover-alert', {
    attrs: {
      "effect": "fade",
      "placement": "left",
      "title": _vm.$Jed.firstUpperTranslate('notification list', null),
      "ok": _vm.toggleNotification,
      "popoverCondition": _vm.showNotifications == true,
      "showOK": false,
      "showNO": false,
      "popoverStyle": {
        top: '10px',
        'max-width': '350px',
        width: '350px',
        'font-size': 'small',
        height: 'max-content'
      },
      "arrowStyle": {
        top: '12%'
      },
      "textStyle": {
        color: '#222'
      },
      "classes": ""
    }
  }, [_c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'notification',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.toggleNotification : !_vm.$root.help ? _vm.toggleNotification : _vm.$root.trigger_help,
      "execParam": ['notification'],
      "hoverParam": 'notification',
      "icnClasses": ['navbar-icon-right', _vm.$root.icons.message],
      "count": _vm.notifCount
    }
  }), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('pending-notifications')], 1)], 2), _vm._v(" "), (_vm.$Behaviors.showUserManualIcon) ? _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'show_user_manual',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.showUserManual : !_vm.$root.help ? _vm.showUserManual : _vm.$root.trigger_help,
      "execParam": ['show_user_manual'],
      "hoverParam": 'show_user_manual',
      "icnClasses": ['navbar-icon-right', _vm.$root.icons.user_manual]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$root.token.categoriaCliente == 'Distributore' && !_vm.$Components['goto_distrib'].hidden) ? _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'goto_distrib',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.goToDistrib : !_vm.$root.help ? _vm.goToDistrib : _vm.$root.trigger_help,
      "hoverParam": 'goto_distrib',
      "icnClasses": ['navbar-icon-right', _vm.$root.icons.userAgent]
    }
  }) : _vm._e(), _vm._v(" "), _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'show_user_data',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.showUserData : !_vm.$root.help ? _vm.showUserData : _vm.$root.trigger_help,
      "execParam": ['show_user_data'],
      "hoverParam": 'show_user_data',
      "icnClasses": ['navbar-icon-right', _vm.$root.icons.user]
    }
  }), _vm._v(" "), _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'toggle_fullscreen',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.toggleFullScreen : !_vm.$root.help ? _vm.toggleFullScreen : _vm.$root.trigger_help,
      "execParam": ['toggle_fullscreen'],
      "hoverParam": 'toggle_fullscreen',
      "icnClasses": ['navbar-icon-right', _vm.fullscreen]
    }
  }), _vm._v(" "), _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'logout',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.doLogoutModal : !_vm.$root.help ? _vm.doLogoutModal : _vm.$root.trigger_help,
      "execParam": ['logout'],
      "hoverParam": 'logout',
      "icnClasses": ['navbar-icon-right', _vm.$root.icons.logout, _vm.$root.help ? ' help' : ''],
      "styleObj": {
        'margin-right': '10px'
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('sidebar', {
    attrs: {
      "right": _vm.right
    }
  }), _vm._v(" "), _c('aside', {
    staticClass: "table-resize-reset resize-stop sup-resize-stop",
    class: [_vm.right ? 'pull-right control-sidebar wtree_right maintree wtree_fake_right right_fix' : 'main-sidebar pull-left wtree_left wtree_fake_left '],
    staticStyle: {
      "z-index": "-1",
      "background-color": "rgba(255,255,255,0.3)",
      "border": "1px ridge #999",
      "margin-top": "55px"
    },
    attrs: {
      "id": "side-shadow"
    }
  }), _vm._v(" "), _c('aside', {
    staticClass: "table-resize-reset resize-stop sup-resize-stop sidebar-left main-sidebar pull-left toolbar",
    staticStyle: {
      "width": "50px",
      "padding-top": "10px",
      "margin-top": "50px",
      "text-align": "center"
    },
    attrs: {
      "id": "side-toolbar"
    }
  }, [_c('cfg', {
    attrs: {
      "cid": "toolbar.catalog_icon",
      "tag": "i"
    }
  }, [_c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'show_catalog_tree',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.showContent : !_vm.$root.help ? _vm.showContent : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['show_catalog_tree', _vm.mainSidebarOpened ? 'close' : 'open', null, 'openSidebarMenu'] : !_vm.$root.help ? ['show_catalog_tree', _vm.mainSidebarOpened ? 'close' : 'open', null, 'openSidebarMenu'] : ['show_catalog_tree'],
      "hoverParam": 'show_catalog_tree',
      "icnClasses": [_vm.$root.help ? ' help' : '', _vm.$root.icons.tree, _vm.active == 'show_catalog_tree' ? ' active' : '', _vm.$root.BLOCK_NAVIGATION ? ' disable' : ''],
      "styleObj": {
        'color': '#ecf0f5',
        'padding': '10px 0px',
        'display': 'block'
      }
    }
  })], 1), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "toolbar.search_icon",
      "tag": "i"
    }
  }, [_c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'show_search',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.showContent : !_vm.$root.help ? _vm.showContent : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['show_search', _vm.mainSidebarOpened ? 'close' : 'open', null, 'openSearchMenu'] : !_vm.$root.help ? ['show_search', _vm.mainSidebarOpened ? 'close' : 'open', null, 'openSearchMenu'] : ['show_search'],
      "hoverParam": 'show_search',
      "icnClasses": [_vm.$root.help ? ' help' : '', _vm.$root.icons.search, _vm.active == 'show_search' ? ' active' : '', _vm.$root.BLOCK_NAVIGATION ? ' disable' : ''],
      "styleObj": {
        'color': '#ecf0f5',
        'padding': '10px 0px',
        'display': 'block'
      }
    }
  })], 1), _vm._v(" "), (!this.$root.blockCart) ? _c('cfg', {
    attrs: {
      "cid": "toolbar.cart_icon",
      "tag": "i"
    }
  }, [(!this.$Configs.ecp.ecidUrl) ? _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'show_cart',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.showContent : !_vm.$root.help ? _vm.showContent : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['show_cart', 'close', 'ShopCart', null] : !_vm.$root.help ? ['show_cart', 'close', 'ShopCart', null] : ['show_cart'],
      "hoverParam": 'show_cart',
      "icnClasses": [_vm.$root.help ? ' help' : '', _vm.$root.icons.cart, _vm.active == 'show_cart' ? ' active' : '', _vm.$root.BLOCK_NAVIGATION ? ' disable' : ''],
      "styleObj": {
        'color': '#ecf0f5',
        'padding': '10px 0px',
        'display': 'block'
      },
      "count": _vm.$Behaviors.quantityOnCartIcon ? _vm.cartCount : 0
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!this.$root.ecIntegrationActive && !this.$root.blockCart) ? _c('cfg', {
    attrs: {
      "cid": "toolbar.archive_icon",
      "tag": "i"
    }
  }, [(!this.$Configs.ecp.ecidUrl) ? _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'show_archive',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.showContent : !_vm.$root.help ? _vm.showContent : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['show_archive', 'close', 'OrdersArch', null] : !_vm.$root.help ? ['show_archive', 'close', 'OrdersArch', null] : ['show_archive'],
      "hoverParam": 'show_archive',
      "icnClasses": [_vm.$root.help ? ' help' : '', _vm.$root.icons.archive, _vm.active == 'show_archive' ? ' active' : '', _vm.$root.BLOCK_NAVIGATION ? ' disable' : ''],
      "styleObj": {
        'color': '#ecf0f5',
        'padding': '10px 0px',
        'display': 'block'
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "toolbar.preference_icon",
      "tag": "i"
    }
  }, [(_vm.$Behaviors.enablePreferences) ? _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'show_preference',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.showContent : !_vm.$root.help ? _vm.showContent : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['show_preference', 'close', 'preferences', null] : !_vm.$root.help ? ['show_preference', 'close', 'preferences', null] : ['show_preference'],
      "hoverParam": 'show_preference',
      "icnClasses": [_vm.$root.help ? ' help' : '', _vm.$root.icons.check_list, _vm.active == 'show_preference' ? ' active' : '', _vm.$root.BLOCK_NAVIGATION ? ' disable' : ''],
      "styleObj": {
        'color': '#ecf0f5',
        'padding': '10px 0px',
        'display': 'block'
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "toolbar.sync_icon",
      "tag": "i"
    }
  }, [(_vm.$root.preferences.useOffline && _vm.$root.preferences.sincro == 'Manual') ? _c('i', {
    class: this.$root.icons.sync + (_vm.$root.help ? ' help' : ''),
    staticStyle: {
      "color": "#ecf0f5",
      "padding": "10px 0px 25px 0px",
      "margin-left": "7px !important",
      "display": "block",
      "position": "absolute",
      "bottom": "35px",
      "cursor": "pointer"
    },
    attrs: {
      "id": "manual_sync",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        !_vm.$root.help ? _vm.$root.manualSync() : _vm.$root.trigger_help('manual_sync')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('popover-alert', {
    attrs: {
      "effect": "fade",
      "placement": "right",
      "content": _vm.info_popup_content,
      "ok": _vm.toggleInfoSw,
      "popoverCondition": _vm.info_software == true,
      "popoverStyle": {
        top: 'calc(100% - 100px)',
        left: '50px',
        'max-width': '200px',
        width: '200px',
        'font-size': 'small',
        height: 'max-content'
      },
      "arrowStyle": {
        top: '75%'
      },
      "showOK": true,
      "ok_text": _vm.$Jed.firstUpperTranslate('close'),
      "showNO": false,
      "textStyle": {
        color: '#222'
      }
    }
  }, [_c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'show_info_sw',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.toggleInfoSw : !_vm.$root.help ? _vm.toggleInfoSw : _vm.$root.trigger_help,
      "execParam": ['show_info_sw'],
      "hoverParam": 'show_info_sw',
      "icnClasses": [_vm.$root.help ? ' help' : '', _vm.$root.icons.info],
      "styleObj": {
        'color': '#ecf0f5',
        'padding': '10px 0px 25px 0px',
        'display': 'block',
        'position': 'absolute',
        'bottom': '-12px',
        'cursor': 'pointer'
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.helpers), function(h) {
    return _c('help-popover', {
      key: h.id,
      attrs: {
        "helpProp": h.id,
        "reference": h.id,
        "msg": _vm.$Jed.firstUpperTranslate(h.msg),
        "offset": h.pos
      }
    })
  }), _vm._v(" "), (_vm.openSupportSidebar) ? _c('support-sidebar', {
    attrs: {
      "right": _vm.right,
      "content": _vm.supportContent
    },
    on: {
      "closeme": _vm.noWrapperRoute
    }
  }) : _vm._e(), _vm._v(" "), (_vm.openSupportSidebar) ? _c('aside', {
    staticClass: "table-resize-reset resize-stop sup-resize-stop",
    class: [!_vm.right ? 'pull-right control-sidebar wtree_right wtree_fake_right right_fix' : 'main-sidebar pull-left wtree_left wtree_fake_left '],
    staticStyle: {
      "z-index": "-1",
      "background-color": "rgba(255,255,255,0.3)",
      "border": "1px ridge #999",
      "margin-top": "55px"
    },
    attrs: {
      "id": "side-shadow"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSupportSidebar) ? _c('aside', {
    staticClass: "table-resize-reset resize-stop sup-resize-stop sidebar-right main-sidebar pull-right toolbar right_fix",
    staticStyle: {
      "width": "50px",
      "padding-top": "10px",
      "margin-top": "55px",
      "text-align": "center",
      "z-index": "812"
    },
    attrs: {
      "id": "extra-toolbar"
    }
  }, [_c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'switch_detail',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.viewTo : !_vm.$root.help ? _vm.viewTo : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['Detail'] : !_vm.$root.help ? ['Detail'] : ['switch_detail'],
      "hoverParam": 'switch_detail',
      "icnClasses": [_vm.activeView == 'Detail' ? ' active-view' : '', _vm.$root.icons.detail, 'support-tool-icon']
    }
  }), _vm._v(" "), _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'switch_table',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.viewTo : !_vm.$root.help ? _vm.viewTo : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['TableLayout'] : !_vm.$root.help ? ['TableLayout'] : ['switch_table'],
      "hoverParam": 'switch_table',
      "icnClasses": [_vm.activeView == 'TableLayout' ? ' active-view' : '', _vm.$root.icons.table, 'support-tool-icon']
    }
  }), _vm._v(" "), _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'switch_img',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.viewTo : !_vm.$root.help ? _vm.viewTo : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['ImgLayout'] : !_vm.$root.help ? ['ImgLayout'] : ['switch_img'],
      "hoverParam": 'switch_img',
      "icnClasses": [_vm.activeView == 'ImgLayout' ? ' active-view' : '', _vm.$root.icons.image, 'support-tool-icon']
    }
  }), _vm._v(" "), _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'switch_grid',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.viewTo : !_vm.$root.help ? _vm.viewTo : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['GridLayout'] : !_vm.$root.help ? ['GridLayout'] : ['switch_grid'],
      "hoverParam": 'switch_grid',
      "icnClasses": [_vm.activeView == 'GridLayout' ? ' active-view' : '', _vm.$root.icons.grid, 'support-tool-icon'],
      "styleObj": {
        'padding': '10px 0px 15px 0px',
        'border-bottom': '1px solid #090c0f',
        'box-shadow': 'rgb(80, 94, 101) 0px 1px 0px;'
      }
    }
  }), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "supportSidebar.anteprime",
      "tag": "div"
    }
  }, [_c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'support_anteprime',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.openTo : !_vm.$root.help ? _vm.openTo : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['Anteprime'] : !_vm.$root.help ? ['Anteprime'] : ['support_anteprime'],
      "hoverParam": 'support_anteprime',
      "icnClasses": [_vm.supportContent == 'Anteprime' ? ' active-content' : '', _vm.$root.icons.preview, 'support-tool-icon'],
      "styleObj": {
        'padding': '15px 0px 10px 0px'
      }
    }
  })], 1), _vm._v(" "), _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'support_impiego',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.openTo : !_vm.$root.help ? _vm.openTo : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['Impiego'] : !_vm.$root.help ? ['Impiego'] : ['support_impiego'],
      "hoverParam": 'support_impiego',
      "icnClasses": [_vm.supportContent == 'Impiego' ? ' active-content' : '', _vm.$root.icons.use, 'support-tool-icon']
    }
  }), _vm._v(" "), (!_vm.$Components['support_documenti'].hidden) ? _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'support_documenti',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.openTo : !_vm.$root.help ? _vm.openTo : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['Documenti'] : !_vm.$root.help ? ['Documenti'] : ['support_documenti'],
      "hoverParam": 'support_documenti',
      "icnClasses": [_vm.supportContent == 'Documenti' ? ' active-content' : '', _vm.$root.icons.documents, 'support-tool-icon'],
      "styleObj": {
        'padding': '10px 0px 15px 0px',
        'border-bottom': '1px solid #090c0f',
        'box-shadow': 'rgb(80, 94, 101) 0px 1px 0px'
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('dynIcon', {
    attrs: {
      "configs": {
        ID: 'show_print',
        visible: true
      },
      "exec": _vm.hoverTooltipEnabled ? _vm.openTo : !_vm.$root.help ? _vm.openTo : _vm.$root.trigger_help,
      "execParam": _vm.hoverTooltipEnabled ? ['Stampa'] : !_vm.$root.help ? ['Stampa'] : ['show_print'],
      "hoverParam": 'show_print',
      "icnClasses": [_vm.supportContent == 'Stampa' ? ' active-content' : '', _vm.$root.icons.print, 'support-tool-icon']
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper resize-stop sup-resize-stop table-resize-stop",
    class: [_vm.right ? 'mtree_right' : 'mtree_left'],
    staticStyle: {
      "position": "relative",
      "transition": "none",
      "overflow-y": "hidden"
    },
    style: ([{
      'max-height': _vm.maxHeight
    }, _vm.overrideMtree_left]),
    attrs: {
      "id": "route-view-parent"
    }
  }, [_c('router-view', {
    attrs: {
      "right": _vm.right
    },
    on: {
      "togglesupport": _vm.handleSupportSidebar,
      "closesupport": _vm.noWrapperRoute
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "id": "m-wrap"
    }
  }, [_c('modal-select')], 1), _vm._v(" "), _c('single-modal', {
    attrs: {
      "title": _vm.$Jed.firstUpperTranslate('warning'),
      "options": _vm.criteriaModalConfigs
    },
    on: {
      "API": function($event) {
        _vm.CriteriaModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-input"
  }, [_c('label', [_vm._v(_vm._s(this.criteriaModalConfigs.content))])])]), _vm._v(" "), _c('alert', {
    attrs: {
      "message": _vm.alertOPT.message,
      "type": _vm.alertOPT.type,
      "closeModal": _vm.alertOPT.action
    },
    on: {
      "API": function($event) {
        _vm.alertAPI = $event
      }
    }
  }), _vm._v(" "), _c('confirm', {
    attrs: {
      "message": _vm.confirmOPT.message,
      "Ycallback": _vm.confirmOPT.Ycallback,
      "Ncallback": _vm.confirmOPT.Ncallback,
      "YtxtBtn": _vm.confirmOPT.YtxtBtn,
      "NtxtBtn": _vm.confirmOPT.NtxtBtn,
      "title": _vm.confirmOPT.title,
      "icon": _vm.confirmOPT.icon
    },
    on: {
      "API": function($event) {
        _vm.confirmAPI = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help_mode_overlay",
    attrs: {
      "id": "wrapper_overlay"
    }
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed046dfe","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 1568
// module chunks = 1